var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 21,
    viewBox: "0 0 40 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.243219 20.5V0.899999H8.02722C9.22189 0.899999 10.2859 1.14267 11.2192 1.628C12.1712 2.09467 12.9086 2.76667 13.4312 3.644C13.9726 4.50267 14.2432 5.53867 14.2432 6.752V7.116C14.2432 8.32933 13.9632 9.37467 13.4032 10.252C12.8619 11.1293 12.1246 11.8013 11.1912 12.268C10.2579 12.7347 9.20322 12.968 8.02722 12.968H3.26722V20.5H0.243219ZM3.26722 10.224H7.71922C8.78322 10.224 9.63255 9.944 10.2672 9.384C10.9019 8.824 11.2192 8.05867 11.2192 7.088V6.808C11.2192 5.81867 10.9019 5.044 10.2672 4.484C9.63255 3.924 8.78322 3.644 7.71922 3.644H3.26722V10.224Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1143 20.5V0.899999H20.1383V20.5H17.1143ZM23.4957 20.5V17.812H26.1277V3.588H23.4957V0.899999H31.3357C33.949 0.899999 35.9464 1.56267 37.3277 2.888C38.7277 4.21333 39.4277 6.21067 39.4277 8.88V12.548C39.4277 15.2173 38.7277 17.2147 37.3277 18.54C35.9464 19.8467 33.949 20.5 31.3357 20.5H23.4957ZM29.1797 17.756H31.3637C33.0624 17.756 34.3224 17.3267 35.1437 16.468C35.965 15.6093 36.3757 14.3307 36.3757 12.632V8.768C36.3757 7.05067 35.965 5.772 35.1437 4.932C34.3224 4.092 33.0624 3.672 31.3637 3.672H29.1797V17.756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPidIcon);
export default __webpack_public_path__ + "static/media/pidIcon.2168817f74246e724e5db8beafb5fb73.svg";
export { ForwardRef as ReactComponent };